import type { HTMLAttributes } from "react";
import { cn } from "@/shared/lib/cn";

/** Skeleton — gentle shimmer; respect reduce-motion globally via CSS. */
export function Skeleton({ className, ...p }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "rounded-[var(--radius-md)] bg-[var(--bg-subtle)] relative overflow-hidden",
        "before:absolute before:inset-0 before:-translate-x-full",
        "before:bg-gradient-to-r before:from-transparent before:via-white/30 before:to-transparent",
        "before:animate-[shimmer_1.6s_var(--ease-out-soft)_infinite]",
        className,
      )}
      {...p}
    />
  );
}
